import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetFlowActionByTaskId = createAsyncThunk(
  "FlowAction/GetFlowActionByTaskId",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/FlowAction/GetFlowActionByTaskId",
        parameters
      );

      const data = response.data.result; 

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const UpdateActionFlowForSubTasks = createAsyncThunk(
  "FlowAction/UpdateActionFlowForSubTasks",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/FlowAction/UpdateActionFlowForSubTasks",
        parameters
      );

      const data = response.data.result; 

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const FlowActionByTaskId = createSlice({
  name: "FlowActionByTaskId",
  initialState: {
    FlowActionByTaskId: {},
    loadingFlowActionByTaskId: false,
    errorFlowActionByTaskId: null,

    ////////////////////////////////////////////////
    UpdateFlowActionByTask: {},
    loadingUpdateFlowActionByTask: false,
    errorUpdateFlowActionByTask: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetFlowActionByTaskId.pending, (state, action) => {
        state.loadingFlowActionByTaskId = true;
        state.FlowActionByTaskId = action.payload;
        state.errorFlowActionByTaskId = null;
      })
      .addCase(GetFlowActionByTaskId.fulfilled, (state, action) => {
        state.loadingFlowActionByTaskId = false;
        state.FlowActionByTaskId = action.payload;
      })
      .addCase(GetFlowActionByTaskId.rejected, (state, action) => {
        state.loadingFlowActionByTaskId = false;
        state.errorFlowActionByTaskId = action.payload;
      });


      builder
      .addCase(UpdateActionFlowForSubTasks.pending, (state, action) => {
        state.loadingUpdateFlowActionByTask = true;
        state.UpdateFlowActionByTask = action.payload;
        state.errorUpdateFlowActionByTask = null;
      })
      .addCase(UpdateActionFlowForSubTasks.fulfilled, (state, action) => {
        state.loadingUpdateFlowActionByTask = false;
        state.UpdateFlowActionByTask = action.payload;
      })
      .addCase(UpdateActionFlowForSubTasks.rejected, (state, action) => {
        state.loadingUpdateFlowActionByTask = false;
        state.UpdateFlowActionByTask = action.payload;
      });
  },
});

export default FlowActionByTaskId.reducer;
